import Quill from 'quill';

// Custom SmartLinks module that auto-detects URLs and converts them to links
// URLs starting with www. are automatically prefixed with https://
class SmartLinksWithProtocol {
  private quill: Quill;
  private linkRegex: RegExp;

  constructor(quill: Quill, options: { linkRegex?: RegExp } = {}) {
    this.quill = quill;
    this.linkRegex = options.linkRegex || /(https?:\/\/[^\s]+)|(www\.[^\s]+)/;

    this.quill.on('text-change', (delta) => {
      const selection = this.quill.getSelection(false);
      const cursorIndex = selection?.index;
      if (cursorIndex === null || cursorIndex === undefined) return;

      const [leaf] = this.quill.getLeaf(cursorIndex);
      if (!leaf) return;

      // Get what was just inserted
      const insertedText = delta?.ops?.filter((op: { insert?: unknown }) => op.insert)?.map((op: { insert?: unknown }) => op.insert)?.[0];
      const text = leaf.value?.();
      
      if (!text || typeof text !== 'string') return;
      
      // Skip if already inside a link
      if (leaf.parent?.domNode?.localName === 'a') return;

      // Check for trigger characters (space, enter, tab)
      const triggerChars = ['\n', '\t', ' '];
      const isTrigger = triggerChars.some(c => c === insertedText);

      // Find URL match in the text
      const match = text.match(this.linkRegex);
      if (!match || !match[0]) return;

      const url = match[0];
      const urlStart = text.indexOf(url);
      if (urlStart === null || urlStart === undefined) return;

      const leafIndex = this.quill.getIndex(leaf);
      const absoluteStart = leafIndex + urlStart;
      const absoluteEnd = absoluteStart + url.length;

      // Only convert if cursor is after the URL or a trigger was pressed
      if (!isTrigger && cursorIndex <= absoluteEnd && cursorIndex > absoluteStart) return;

      // Normalize URL: add https:// if it starts with www.
      let href = url;
      if (href.startsWith('www.')) {
        href = 'https://' + href;
      }

      // Delete the text and re-insert as a link with proper href
      this.quill.deleteText(absoluteStart, url.length, 'api');
      this.quill.insertText(absoluteStart, url, 'link', href, 'api');
    });
  }
}

// Register module globally for Quill
Quill.register('modules/smartLinks', SmartLinksWithProtocol);

// Default configuration for smart links
// Matches: http://, https://, and www. URLs
// www. URLs are automatically prefixed with https:// when creating the link
export const SMART_LINKS_CONFIG = {
  smartLinks: {
    linkRegex: /(https?:\/\/[^\s]+)|(www\.[^\s]+)/
  }
};
